import { render, staticRenderFns } from "./V2WishlistPriceSourceSection.vue?vue&type=template&id=11db6662&scoped=true&"
import script from "./V2WishlistPriceSourceSection.vue?vue&type=script&lang=js&"
export * from "./V2WishlistPriceSourceSection.vue?vue&type=script&lang=js&"
import style0 from "./V2WishlistPriceSourceSection.vue?vue&type=style&index=0&id=11db6662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11db6662",
  null
  
)

export default component.exports